"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.keys.js");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _set2 = _interopRequireDefault(require("lodash/set"));

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _currency = require("@nerdwallet/currency");

var _impression = require("@nerdwallet/analytics/react/impression");

var _authFlowButtonModule = _interopRequireDefault(require("./auth-flow-button.module.css"));

var _openers = _interopRequireDefault(require("./openers"));

var _excluded = ["flowPreset", "flowProps", "hideButtonAppearance", "onClick", "ctaLabel"],
    _excluded2 = ["analytics", "flowPreset", "authType", "ctaLabel", "entityName"];

/**
 * Helper component that wraps children in a button component for accessibility.
 */
var NoAppearanceButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/button-has-type
    _react.default.createElement("button", (0, _extends2.default)({
      className: _authFlowButtonModule.default['no-appearance-button']
    }, props, {
      ref: ref
    }))
  );
});

NoAppearanceButton.displayName = 'NoAppearanceButton';
/**
 * Button that when clicked opens an Auth Dialog with the desired flow.
 * Renders as a NW Button component unless indicated not to.
 * All non-named props (e.g. children) are passed down to the button.
 *
 * @return {func} component
 */

var AuthFlowButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var flowPreset = props.flowPreset,
      flowProps = props.flowProps,
      hideButtonAppearance = props.hideButtonAppearance,
      onClick = props.onClick,
      ctaLabel = props.ctaLabel,
      buttonProps = (0, _objectWithoutProperties2.default)(props, _excluded); // Deprecation warning for old flows

  if (process.env.CONFIG_ENV === 'development' && flowPreset === 'basic') {
    /* eslint-disable no-console */
    console.warn('basic flow is deprecated. Use onboardingGeneric or another flow.');
    /* eslint-enable no-console */
  }

  var ButtonComponent = hideButtonAppearance ? NoAppearanceButton : _currency.Button;

  var regOnClick = function regOnClick(e) {
    // Opener
    (0, _get2.default)(_openers.default, flowPreset, function () {})(flowProps); // User's requested onClick

    onClick(e);
  };

  return /*#__PURE__*/_react.default.createElement(ButtonComponent, (0, _extends2.default)({
    onClick: regOnClick,
    primary: !hideButtonAppearance
  }, buttonProps, {
    ref: ref
  }));
});

AuthFlowButton.displayName = 'AuthFlowButton';
AuthFlowButton.defaultProps = {
  onClick: function onClick() {}
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  AuthFlowButton.propTypes = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _currency.Button.propTypes), {}, {
    /** Desired auth flow. */
    flowPreset: PropTypes.oneOf((0, _toConsumableArray2.default)(Object.keys(_openers.default))).isRequired,

    /** Optional cta_label override prop */
    // eslint-disable-next-line react/require-default-props
    ctaLabel: PropTypes.string,

    /**
     * Uses a button with no appearance instead of Primary Button.
     */
    // eslint-disable-next-line react/require-default-props
    hideButtonAppearance: PropTypes.bool,

    /**
     * Optional params passed to showAuthDialog.
     * See https://github.com/NerdWallet/nw-auth-dialog/wiki/Beta:-new-onboarding-flows
     */
    // eslint-disable-next-line react/require-default-props
    flowProps: PropTypes.shape({
      /** Custom flow configuration for NW Auth Dialog. */
      flowConfig: PropTypes.shape({
        createGoal: PropTypes.shape({
          goal_type: PropTypes.string,
          goal_subtype: PropTypes.string
        })
      }),

      /**
       * Tracking params for NW Auth Dialog.
       * See https://github.com/NerdWallet/nw-auth-dialog/wiki/Examples
       */
      trk: PropTypes.shape({
        trk_copy: PropTypes.string,
        navigation_source_impression_id: PropTypes.string
      }),

      /**
       * Changes the authType of the NW Auth Dialog.
       * This flag controls whether the user will initially see the sign in or register step.
       */
      authType: PropTypes.oneOf(['register', 'signin']),

      /**
       * Overrides the callback when the modal is successfully completed
       */
      onSuccess: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.bool]),

      /**
       * Segment tracking attributes passed to the identify call that runs onSuccess
       */
      segmentTrackingAttributes: PropTypes.shape({
        driverPageName: PropTypes.string,
        driverLocation: PropTypes.string,
        driverSubLocation: PropTypes.string,
        driverElement: PropTypes.string,
        deployableName: PropTypes.string,
        deployableVersion: PropTypes.string,
        driverPageViewId: PropTypes.string,
        driverContentId: PropTypes.string,
        driverContentSource: PropTypes.string,
        driverFlowName: PropTypes.string
      })
    }),

    /** Function to be fired along with reg modal opener. */
    onClick: PropTypes.func
  });
}

var BaseAuthFlowButtonWithTracking = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var impressionContext = (0, _react.useContext)(_impression.ImpressionContext);
  var newProps = (0, _cloneDeep2.default)(props);
  (0, _set2.default)(newProps, 'flowProps.trk.navigation_source_impression_id', impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
  return /*#__PURE__*/_react.default.createElement(AuthFlowButton, (0, _extends2.default)({}, newProps, {
    ref: ref
  }));
});

BaseAuthFlowButtonWithTracking.propTypes = (0, _objectSpread2.default)({}, AuthFlowButton.propTypes);
BaseAuthFlowButtonWithTracking.defaultProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, AuthFlowButton.defaultProps), {}, {
  entityName: 'auth_flow_button'
});

var AuthFlowButtonWithTracking = function AuthFlowButtonWithTracking(_ref) {
  var analytics = _ref.analytics,
      flowPreset = _ref.flowPreset,
      authType = _ref.authType,
      ctaLabel = _ref.ctaLabel,
      entityName = _ref.entityName,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded2);

  var ctaRef = _react.default.useRef();

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      label = _useState2[0],
      setLabel = _useState2[1]; // Extracts the text of the button after it's rendered to use when firing `registration_cta_impression` event


  (0, _react.useEffect)(function () {
    var _ctaRef$current;

    setLabel(ctaRef === null || ctaRef === void 0 ? void 0 : (_ctaRef$current = ctaRef.current) === null || _ctaRef$current === void 0 ? void 0 : _ctaRef$current.innerText);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  [ctaRef.current]);
  return /*#__PURE__*/_react.default.createElement(_impression.Impression, {
    eventType: "registration_cta_impression",
    entityName: entityName || 'auth_flow_button',
    payload: {
      additional_attributes: {
        target_flow: flowPreset,
        cta_mode: 'modal',
        auth_type: authType,
        cta_format: 'button',
        cta_label: ctaLabel || label
      },
      element_position: analytics === null || analytics === void 0 ? void 0 : analytics.elementPosition,
      section_name: analytics === null || analytics === void 0 ? void 0 : analytics.sectionName,
      section_position: analytics === null || analytics === void 0 ? void 0 : analytics.sectionPosition
    }
  }, /*#__PURE__*/_react.default.createElement(BaseAuthFlowButtonWithTracking, (0, _extends2.default)({
    ref: ctaRef,
    flowPreset: flowPreset,
    authType: authType,
    ctaLabel: ctaLabel,
    entityName: entityName
  }, props)));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var _PropTypes = require('prop-types');

  AuthFlowButtonWithTracking.propTypes = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, BaseAuthFlowButtonWithTracking.propTypes), {}, {
    /**
     * Entity name for the bedrock impression event
     */
    entityName: _PropTypes.string,
    analytics: _PropTypes.shape({
      sectionName: _PropTypes.string,
      sectionPosition: _PropTypes.string,
      elementPosition: _PropTypes.string
    })
  });
}

AuthFlowButtonWithTracking.defaultProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, BaseAuthFlowButtonWithTracking.defaultProps), {}, {
  entityName: 'auth_flow_button'
});
AuthFlowButtonWithTracking.displayName = 'AuthFlowButtonWithTracking';
var _default = AuthFlowButtonWithTracking;
exports.default = _default;